import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class BikeflipPdpBelow extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  updateContent = (event) => {
    if (!event?.detail?.data?.html) return;

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId && event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const selector = `#shopify-section-${this.dataset.sectionId} bikeflip-pdp-below`;
    const newContent = event.detail.data.html.querySelector(selector) || event.detail.data.html.querySelector('bikeflip-pdp-below');

    if (!newContent) return;
    this.replaceWith(newContent);
  };
}

if (!customElements.get('bikeflip-pdp-below')) {
  customElements.define('bikeflip-pdp-below', BikeflipPdpBelow);
}
